/**
 * 인증이 필요한 API 요청을 처리하는 함수
 *
 * - access_token이 만료되어 401 응답이 오면 /refresh API를 호출하여 자동으로 access_token을 재발급합니다.
 * - refresh 성공 시 원래 요청을 자동 재시도합니다.
 * - refresh도 실패하면 에러를 throw하여 로그아웃 처리로 연결할 수 있도록 합니다.
 *
 * @param {string} path - API 경로 (예: "/me", "/users/1")
 * @param {Object} [options={}] - fetch 옵션 객체 (headers, method, body 등)
 * @returns {Promise<Response>} fetch의 Response 객체를 반환
 *
 * @throws {Error} 세션 만료 또는 네트워크 오류 발생 시 에러를 throw합니다.
 *
 * @example
 * const res = await apiFetch('/me');
 * const data = await res.json();
 */
export async function apiFetch(path, options = {}) {
    const res = await fetch(`${import.meta.env.VITE_API_BASE}/api${path}`, {
        credentials: 'include',
        ...options,
    });

    // access_token 만료 시 재발급
    if (res.status === 401) {
        const refreshRes = await fetch(`${import.meta.env.VITE_API_BASE}/api/auth/refresh`, {
            method: 'POST',
            credentials: 'include',
        });

        if (refreshRes.ok) {
            // 재시도
            const retry = await fetch(`${import.meta.env.VITE_API_BASE}/api${path}`, {
                credentials: 'include',
                ...options,
            });
            return retry;
        } else {
            // refresh도 실패 → 로그아웃 처리
            throw new Error('세션이 만료되었습니다. 다시 로그인해주세요.');
        }
    }

    return res;
}